import {
    AgeVerificationBarcodeCreator,
    BasicBarcodeCreator,
    CrccsBarcodeCreator,
    LinkBarcodeCreator,
    QuickConnectBarcodeCreator,
    SmsBarcodeCreator,
    SplitJsBarcodeCreator,
    VcardBarcodeCreator,
    WifiBarcodeCreator,
} from './barcode-creators'
import { BarcodeTabs } from './components/barcode-tabs'
import PlainImg from './images/PlainTextIcon.svg'
import LinkImg from './images/LinkIcon.svg'
import WifiImg from './images/WifiIcon.svg'
import SMSImg from './images/SmsIcon.svg'
import ShareContactImg from './images/ShareContactIcon.svg'
import CustomConfImg from './images/CustomConfigIcon.svg'
import BluetoothImg from './images/Bluetooth_FM_Black.svg'
import AgeVerImg from './images/AgeVerIcon.svg'
import SplitJsImg from './images/SplitJsIcon.svg'
import LockImg from './images/Lock.svg'
import { SetStateAction, useState } from 'react'
import { ModalProvider } from '@codecorp/components'
import { LockUnlockBarcode } from './barcode-creators/lock-unlock'

interface DisclaimerProps {
    shouldShow: boolean
}
const Disclaimer = ({ shouldShow }: DisclaimerProps) => {
    return (
        <p className="text-red-600">
            <span className="font-bold">Disclaimer:</span>{' '}
            <ul className="list-disc marker:text-red-600">
                {shouldShow && (
                    <li>
                        QR Codes are compatible only with devices that have a
                        real-time clock (e.g., CR5215).
                    </li>
                )}

                <li>
                    If you forget your PIN, please contact our support team at{' '}
                    <a
                        href="mailto:support@codecorp.com"
                        style={{
                            cursor: 'pointer',
                        }}
                    >
                        support@codecorp.com
                    </a>{' '}
                    or call 801-495-2200.
                </li>
            </ul>
        </p>
    )
}
export const App = () => {
    const tabOptionsStyle =
        'm-auto flex w-full items-center justify-between space-x-4 rounded-md px-2 py-2 pt-10 text-lg sm:w-[80%] sm:space-x-6 sm:px-3 sm:pt-12 sm:text-xl md:w-[70%] md:space-x-8 md:px-4 md:pt-14 lg:w-[90%]'

    const tabOptions = [
        {
            id: 1,
            title: 'Basic',
        },
        {
            id: 2,
            title: 'Advanced',
        },
    ]
    const [activeIndex, setActiveIndex] = useState(1)
    const handleClickTabs = (index: SetStateAction<number>) =>
        setActiveIndex(index)
    const checkActive = (index: number, className: string) =>
        activeIndex === index
            ? className
            : 'h-16 w-3/5 rounded-t-lg bg-red-300 hover:bg-red-500 px-2 py-1 text-lg text-white sm:h-20 sm:w-3/5 sm:px-3 sm:text-xl md:text-2xl'

    return (
        <ModalProvider>
            <div className=" m-auto  w-full rounded-lg bg-gradient-to-b from-gray-200 via-gray-50 to-white pb-20 sm:w-[80%] md:w-full lg:w-full xl:w-full  ">
                <div className="m-auto w-full sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[58%]">
                    <div className={`${tabOptionsStyle}`}>
                        {tabOptions.map((item) => (
                            <button
                                key={item.id}
                                className={`${checkActive(
                                    item.id,
                                    'h-16 w-4/5 rounded-t-lg bg-red-700 px-2 py-1 text-lg text-white sm:h-20 sm:w-3/4 sm:px-3 sm:text-xl md:text-2xl',
                                )}`}
                                onClick={() => handleClickTabs(item.id)}
                            >
                                {item.title}
                            </button>
                        ))}
                    </div>
                </div>
                <div
                    className=""
                    hidden={activeIndex === 2 ? true : false}
                >
                    <BarcodeTabs
                        barcodeCreators={{
                            basic: [
                                {
                                    title: 'Plain Text',
                                    description: (
                                        <>
                                            This type of QR Code allows you to
                                            display a simple text consisting of
                                            words, numbers, and special
                                            characters. It is the most basic QR
                                            Code used and requires no internet
                                            connection to work or be scanned.
                                        </>
                                    ),
                                    icon: (
                                        <img
                                            src={PlainImg}
                                            alt=""
                                        />
                                    ),
                                    component: <BasicBarcodeCreator />,
                                    key: 'basic',
                                },
                                {
                                    title: 'Link',
                                    description: (
                                        <>
                                            Linking to web QR codes makes it
                                            easier for people to open any
                                            webpage without manually typing the
                                            full address into a browser.
                                        </>
                                    ),
                                    icon: (
                                        <img
                                            src={LinkImg}
                                            alt=""
                                        />
                                    ),
                                    component: <LinkBarcodeCreator />,
                                    key: 'link',
                                },
                                {
                                    title: 'Wifi',
                                    description: (
                                        <>
                                            Create a QR Code that allows you to
                                            connect to a WiFi network just by
                                            pointing your camera at it or by
                                            using a QR Code scanner. The
                                            generated QR Code will never expire
                                            (unless the settings on your router
                                            changed). With a WiFi QR Code, you
                                            can also share your WiFi easily with
                                            friends, family, and your customers
                                            if you run a business.
                                        </>
                                    ),
                                    icon: (
                                        <img
                                            src={WifiImg}
                                            alt=""
                                        />
                                    ),
                                    component: <WifiBarcodeCreator />,
                                    key: 'wifi',
                                },
                                {
                                    title: 'SMS',
                                    description: (
                                        <>
                                            SMS QR Code generator allows you to
                                            create a QR Code that sends an SMS
                                            to a target phone number complete
                                            with a pre-filled text message.
                                        </>
                                    ),
                                    icon: (
                                        <img
                                            src={SMSImg}
                                            alt=""
                                        />
                                    ),
                                    component: <SmsBarcodeCreator />,
                                    key: 'sms',
                                },
                                {
                                    title: 'Share Contact',
                                    description: (
                                        <>
                                            Create a QR Code to easily share
                                            your contact information. With a
                                            Share Contact QR Code, you can
                                            effortlessly share your contact
                                            details with friends and family. No
                                            need to manually type out your
                                            information—just scan and share
                                            instantly!
                                        </>
                                    ),
                                    icon: (
                                        <img
                                            src={ShareContactImg}
                                            alt=""
                                        />
                                    ),
                                    component: <VcardBarcodeCreator />,
                                    key: 'vcard',
                                },
                            ],
                        }}
                    />
                </div>
                <div
                    className=""
                    hidden={activeIndex === 1 ? true : false}
                >
                    <BarcodeTabs
                        barcodeCreators={{
                            advanced: [
                                {
                                    title: 'Custom Configure Code Scanners',
                                    description: (
                                        <>
                                            Generates a QR code configuration
                                            barcode from the commands entered in
                                            the textbox for 8200-series readers
                                            (e.g., CR950, CR1500, CR1500DPM,
                                            CR8200). Enter the configuration
                                            commands, separated by a semicolon
                                            (";") if multiple. BarcodeCreator
                                            will process these commands, adding
                                            the necessary CodeXML-protocol
                                            header and trailer for 8200-series
                                            readers, and will generate a QR code
                                            using the processed configuration
                                            command input.
                                        </>
                                    ),
                                    icon: (
                                        <img
                                            src={CustomConfImg}
                                            alt=""
                                        />
                                    ),
                                    component: <CrccsBarcodeCreator />,
                                    key: 'crccs',
                                },
                                {
                                    title: 'Bluetooth® Quick Connect',
                                    description: (
                                        <>
                                            Generates a Quick Connect QR code
                                            from the 12-digit hexadecimal
                                            Bluetooth address for the CR2700
                                            reader. BarcodeCreator validates the
                                            address and generates a barcode to
                                            connect the CR2700 to a base station
                                            with the entered Bluetooth address.
                                        </>
                                    ),
                                    icon: (
                                        <img
                                            src={BluetoothImg}
                                            alt=""
                                        />
                                    ),
                                    component: <QuickConnectBarcodeCreator />,
                                    key: 'quick-connect',
                                },
                                {
                                    title: 'Age Verification',
                                    description: (
                                        <>
                                            A tool designed to generate barcodes
                                            that securely store age-related
                                            information. This barcode generator
                                            is typically used in scenarios
                                            requiring age validation, such as
                                            purchasing age-restricted products
                                            (alcohol, tobacco) or verifying
                                            entry to age-restricted events. The
                                            generated barcode can be scanned to
                                            quickly verify the age of an
                                            individual, ensuring compliance with
                                            legal regulations. Easy to use, it
                                            streamlines the age verification
                                            process while maintaining user
                                            privacy.
                                            <p className="text-red-600">
                                                <span className="font-bold">
                                                    Note:
                                                </span>{' '}
                                                After selecting the Lock Scanner
                                                option, you need to go to the
                                                Lock/Unlock Scanner tab and use
                                                the same PIN to unlock the
                                                device.
                                            </p>
                                            <Disclaimer shouldShow={true} />
                                        </>
                                    ),
                                    icon: (
                                        <img
                                            src={AgeVerImg}
                                            alt=""
                                        />
                                    ),
                                    component: (
                                        <AgeVerificationBarcodeCreator />
                                    ),
                                    key: 'age-verification',
                                },
                                {
                                    title: 'Split JavaScript',
                                    description: (
                                        <>
                                            Some JavaScript files are so big
                                            that can't be encoded in just one QR
                                            code. With Split JavaScript, you'll
                                            be able to split a JS file into
                                            multiple smaller barcodes.
                                        </>
                                    ),
                                    icon: (
                                        <img
                                            src={SplitJsImg}
                                            alt=""
                                        />
                                    ),
                                    component: <SplitJsBarcodeCreator />,
                                    key: 'split-js',
                                },
                                {
                                    title: 'Lock/Unlock Scanner',
                                    description: (
                                        <>
                                            The Lock/Unlock Barcode feature
                                            allows you to secure your barcode by
                                            locking it with a PIN. Once locked,
                                            you must use the same PIN to unlock
                                            the barcode before making any
                                            changes or disabling the lock. This
                                            ensures that only authorized users
                                            with the correct PIN can unlock and
                                            modify the barcode.
                                            <Disclaimer shouldShow={false} />
                                        </>
                                    ),
                                    icon: (
                                        <img
                                            src={LockImg}
                                            alt=""
                                        />
                                    ),
                                    component: <LockUnlockBarcode />,
                                    key: 'lock-unlock',
                                },
                            ],
                        }}
                    />
                </div>
            </div>
        </ModalProvider>
    )
}
